var StepStage;
(function (StepStage) {
    StepStage["CURRENT"] = "current";
    StepStage["NEXT"] = "next";
    StepStage["NONE"] = "";
    StepStage["PREV"] = "prev";
})(StepStage || (StepStage = {}));
export default StepStage;
//# sourceMappingURL=step-stage.js.map